export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "pozeparyaj-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "pozeparyaj-themeWrapLive" */'./LiveThemeImporter'),
  },
};
